import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { ApiService } from '../../core/services/api.service';
import { ApiEnvelope } from '../models/content.models';

export type TestimonialDto = {
  _id: string;
  studentName: string;
  pill?: string;
  review: string;
  rating: number;
  country?: string;
  university?: string;
  course?: string;
  profileImageId?: string;
  status?: 'DRAFT' | 'PUBLISHED';
};

export type CreateTestimonialPayload = {
  studentName: string;
  pill?: string;
  review: string;
  rating: number;
  country?: string;
  university?: string;
  course?: string;
  profileImageId?: string;
  status?: 'DRAFT' | 'PUBLISHED';
};

@Injectable({ providedIn: 'root' })
export class TestimonialsService {
  constructor(private readonly api: ApiService) {}

  listPublic() {
    return this.api.get<ApiEnvelope<TestimonialDto[]>>('public/testimonials').pipe(map((r) => r.data));
  }

  listPlatform() {
    return this.api.get<ApiEnvelope<TestimonialDto[]>>('platform/testimonials').pipe(map((r) => r.data));
  }

  create(payload: CreateTestimonialPayload) {
    return this.api.post<ApiEnvelope<TestimonialDto>>('platform/testimonials', payload).pipe(map((r) => r.data));
  }

  update(id: string, payload: Partial<CreateTestimonialPayload>) {
    return this.api.patch<ApiEnvelope<TestimonialDto>>(`platform/testimonials/${id}`, payload).pipe(map((r) => r.data));
  }

  remove(id: string) {
    return this.api.delete<ApiEnvelope<{ deleted: boolean }>>(`platform/testimonials/${id}`).pipe(map((r) => r.data));
  }
}
